import React from "react";
import color from "@fdr/static-ui/ColorPalette";
import styled, { keyframes } from "styled-components";

const pulseAnimation = keyframes`
  0% {
    fill: ${color("grey", "100")};
  }

  50% {
    fill: ${color("grey", "000")};
  }

  100% {
    fill: ${color("grey", "100")};
  }
`;

const Container = styled.div`
  width: 100%;
  overflow: hidden;
  background-color: white;
`;

const SVG = styled.svg`
  display: block;

  rect.pulse {
    animation: ${pulseAnimation} 1.25s infinite;
  }
`;

const UpcomingRacesMask = () => (
  <Container>
    <SVG
      data-qa-label="upcomingRaces-loadingMask"
      width="375"
      height="171"
      viewBox="0 0 375 171"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="375" height="48" fill="white" />
      <rect
        className="pulse"
        x="16"
        y="16"
        width="166"
        height="15"
        rx="1"
        fill="#0A0A0A"
      />
      <g clipPath="url(#clip0_31980_140960)">
        <rect
          width="375"
          height="122"
          transform="translate(0 48)"
          fill="white"
        />
        <g clipPath="url(#clip1_31980_140960)">
          <rect
            x="15.5"
            y="49.5"
            width="141"
            height="109"
            rx="4.5"
            fill="white"
          />
          <rect
            x="15.5"
            y="49.5"
            width="141"
            height="109"
            rx="4.5"
            stroke="#CFD6DB"
          />
          <rect
            className="pulse"
            x="28"
            y="62"
            width="40"
            height="12"
            rx="1"
            fill="#0A0A0A"
          />
          <rect
            className="pulse"
            x="28"
            y="78"
            width="116"
            height="12"
            rx="1"
            fill="#0A0A0A"
          />
          <rect
            className="pulse"
            x="49"
            y="131"
            width="40"
            height="8"
            rx="1"
            fill="#0A0A0A"
          />
          <rect
            className="pulse"
            x="28"
            y="127"
            width="16"
            height="16"
            rx="8"
            fill="#0A0A0A"
          />
          <rect
            x="163.5"
            y="49.5"
            width="141"
            height="109"
            rx="4.5"
            fill="white"
          />
          <rect
            x="163.5"
            y="49.5"
            width="141"
            height="109"
            rx="4.5"
            stroke="#CFD6DB"
          />
          <rect
            className="pulse"
            x="176"
            y="62"
            width="40"
            height="12"
            rx="1"
            fill="#0A0A0A"
          />
          <rect
            className="pulse"
            x="176"
            y="78"
            width="116"
            height="12"
            rx="1"
            fill="#0A0A0A"
          />
          <rect
            className="pulse"
            x="197"
            y="131"
            width="40"
            height="8"
            rx="1"
            fill="#0A0A0A"
          />
          <rect
            className="pulse"
            x="176"
            y="127"
            width="16"
            height="16"
            rx="8"
            fill="#0A0A0A"
          />
          <rect
            x="311.5"
            y="49.5"
            width="141"
            height="109"
            rx="4.5"
            fill="white"
          />
          <rect
            x="311.5"
            y="49.5"
            width="141"
            height="109"
            rx="4.5"
            stroke="#CFD6DB"
          />
          <rect
            className="pulse"
            x="324"
            y="62"
            width="40"
            height="12"
            rx="1"
            fill="#0A0A0A"
          />
          <rect
            className="pulse"
            x="324"
            y="78"
            width="116"
            height="12"
            rx="1"
            fill="#0A0A0A"
          />
          <rect
            className="pulse"
            x="345"
            y="131"
            width="40"
            height="8"
            rx="1"
            fill="#0A0A0A"
          />
          <rect
            className="pulse"
            x="324"
            y="127"
            width="16"
            height="16"
            rx="8"
            fill="#0A0A0A"
          />
        </g>
      </g>
    </SVG>
  </Container>
);

export default UpcomingRacesMask;
